export const timePeriodFilterEnabled = (metric: MetricsBlockAttributes) =>
    metric.limitToTimePeriodEnabled && metric.limitToTimePeriod && metric.limitToTimePeriodField

export const showPreviousTimePeriod = (metric: MetricsBlockAttributes) =>
    timePeriodFilterEnabled(metric) && metric.compareToPreviousPeriod
